import { ChangeDetectionStrategy, Component } from '@angular/core'

import { Confirmable } from '@app/modules/ui/models/confirmable'
import { UIModule } from '@app/modules/ui/ui.module'

@Component({
  selector: 'sb-voice-message-creator-mic-access-allow',
  templateUrl: './voice-message-creator-mic-access-allow.component.html',
  imports: [UIModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VoiceMessageCreatorMicAccessAllowComponent extends Confirmable {}
